<template>
<div class="UploadBanner">
  <!-- Компонент UploadBanner -->
  <div class=" d-flex align-center gap-7 bg-whiter profile-board ">
    <v-file-input
      class="UploadBanner__input"
      placeholder="Выберите файл"
      :flat="true"
      :hide-details="true"
      v-model="uploadFile.image"
      @change="$emit('updateFile',uploadFile.image)"
    >
    </v-file-input>
    <div >
      <v-btn
        large
        class="UploadBanner__btn"
        color="white"
        outlined
        @click="updateVisibleModal"
      >
        Загрузить
      </v-btn>
    </div>

  </div>
</div>
</template>

<script>
/**
 * Компонент: UploadBanner
 * Описание:
 */
export default {
  name: 'UploadBanner',

  components: {},

  props: {
    uploadFile: {
      type: Object,
      default: () => ({
        isUpload: false,
        image: null,
      }),
    }
  },
  emits: ['openModal', 'updateFile'],

  data() {
    return {
      currentFile: null,
    };
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    updateVisibleModal() {
      this.$emit('openModal', true);
    }
  },
};
</script>

<style scoped  lang="scss">
.UploadBanner {
  /* Стили компонента */
  .v-text-field {
    flex-direction: row-reverse;
    margin: 0;
    border: 1px solid #E4E4E4;
    border-radius: 6px;
    padding: 5px 16px;
    max-width: 376px;
    width: 100%;
    min-width: 376px;
    ::v-deep.v-input__control{
      & .v-input__slot::before{
        display: none;
      }
    }
  }
  & .UploadBanner__btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    height: 100%;
    font-size: 16px;
    padding: 10px 16px;
    margin-left: 8px;
    ::v-deep span{
      line-height: 24px;
    }
  }
  & .profile-board{
    width: fit-content;
  }
}
</style>
